// extracted by mini-css-extract-plugin
module.exports = {"desktopFix":"desktopFix-2ROX9Cv9"};